import React from 'react';

import { ProjectTheme, THEME_LABELS } from './constants';
import type { ProjectCardsProps } from './interfaces';

function splitTitleByTheme(title: string, theme: string | null): [string, string] {
  const themeLabel = theme ? THEME_LABELS[theme] : null;
  if (!themeLabel) return [title, ''];

  const idx = title.lastIndexOf(themeLabel);
  if (idx === -1) return [title, ''];

  return [title.slice(0, idx).trimEnd(), title.slice(idx)];
}

function viewLabel(theme: string | null): string {
  switch (theme) {
    case ProjectTheme.Database:
      return 'View database';
    case ProjectTheme.TalentTracker:
      return 'View tracker';
    default:
      return 'View project';
  }
}

const ProjectCards = ({ projects }: ProjectCardsProps) => {
  return (
    <>
      {projects.map((project) => {
        const [titlePrefix, titleHighlight] = splitTitleByTheme(project.title, project.theme);

        return (
          <a key={project.id} className="group flex flex-col gap-8" href={project.url}>
            <h3 className="m-0 font-suisse-screen text-headline-xxs">
              {titlePrefix}
              {titleHighlight && (
                <>
                  {titlePrefix && ' '}
                  <span className="text-primary-magenta">{titleHighlight}</span>
                </>
              )}
              {!titleHighlight && !titlePrefix && project.title}
            </h3>
            <p className="m-0 line-clamp-2 font-suisse-intl text-body-md">{project.description}</p>
            <span className="font-suisse-intl text-body-md font-medium underline transition-colors duration-150 group-hover:text-primary-magenta">
              {viewLabel(project.theme)}
            </span>
          </a>
        );
      })}
    </>
  );
};

export default ProjectCards;
